/**
 * Portfolio component
 *
 * Highlights some of  your creations. These can be designs, websites,
 * open source contributions, articles you've written and more.
 *
 * This is a great area for you to to continually add to and refine
 * as you continue to learn and create.
 */

import React from "react";

/**
 * Desk image
 *
 * Below is a sample desk image. Feel free to update this to an image of your choice,
 * updating below imageAltText to string that represents what you see in that image.
 *
 * Need an image? Check out https://unsplash.com to download a photo you
 * freely use on your site.
 */
import image from "../images/design-desk.jpeg";

const imageAltText = "desktop with books and laptop";

/**
 * Project list
 *
 * An array of objects that will be used to display for your project
 * links section. Below is a sample, update to reflect links you'd like to highlight.
 */
const projectList = [
  {
    title: "unix-minishell",
    description:
      "A command line interpreter for the Operating Systems course in the Software Engineering Degree.",
    url: "https://github.com/jaimesnh/unix-minishell",
  },
  {
    title: "SelfOrderBurgerKiosk",
    description:
      "A Java-based self-order kiosk application for a burger restaurant, developed as a university coursework project.",
    url: "https://github.com/jaimesnh/SelfOrderBurgerKiosk",
  },
  {
    title: "Java small game system",
    description:
      "VideojuegoMP is a Java project implementing a small game system with different character types (Vampires, Hunters, Lycanthropes), equipment, and challenges.",
    url: "https://github.com/jaimesnh/VideojuegoMP",
  },
  {
    title: "Beers & Cheers Webapp",
    description:
      "A web application to manage and explore a beer catalog. It allows adding new beers, editing existing ones, viewing details, uploading images, and adding comments with ratings.",
    url: "https://github.com/jaimesnh/beers-and-cheers-webapp",
  },
];

const Portfolio = () => {
  return (
    <section className="padding" id="portfolio">
      <h2 style={{ textAlign: "center" }}>Portfolio</h2>
      <div style={{ display: "flex", flexDirection: "row", paddingTop: "3rem" }}>
        <div style={{ maxWidth: "40%", alignSelf: "center" }}>
          <img
            src={image}
            style={{ height: "90%", width: "100%", objectFit: "cover" }}
            alt={imageAltText}
          />
        </div>
        <div className="container">
          {projectList.map((project) => (
            <div className="box" key={project.title}>
              <a href={project.url} target="_blank" rel="noopener noreferrer">
                <h3 style={{ flexBasis: "40px" }}>{project.title}</h3>
              </a>
              <p className="small">{project.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
